var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSystemFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sustem_Fill",
    "data-name": "Sustem Fill",
    transform: "translate(-78 -228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(78 228)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "configuration",
    transform: "translate(81 231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    d: "M212.582,211a1.582,1.582,0,1,0,1.582,1.582A1.584,1.584,0,0,0,212.582,211Zm0,0",
    transform: "translate(-203.582 -203.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    d: "M154.691,151a3.691,3.691,0,1,0,3.691,3.691A3.7,3.7,0,0,0,154.691,151Zm0,6.328a2.637,2.637,0,1,1,2.637-2.637A2.64,2.64,0,0,1,154.691,157.328Zm0,0",
    transform: "translate(-145.691 -145.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M17.576,7.428l-2.016-.4a6.81,6.81,0,0,0-.531-1.278l1.122-1.682a.527.527,0,0,0-.066-.665L14.594,1.915a.527.527,0,0,0-.665-.066L12.245,2.971a6.743,6.743,0,0,0-1.277-.531l-.4-2.016A.527.527,0,0,0,10.055,0H7.945a.527.527,0,0,0-.517.424l-.4,2.016a6.743,6.743,0,0,0-1.277.531L4.072,1.85a.527.527,0,0,0-.665.066L1.915,3.407a.527.527,0,0,0-.066.665L2.971,5.755A6.9,6.9,0,0,0,2.44,7.032l-2.016.4A.527.527,0,0,0,0,7.945v2.109a.527.527,0,0,0,.424.517l2.016.4a6.926,6.926,0,0,0,.531,1.278L1.849,13.928a.527.527,0,0,0,.066.665l1.491,1.491a.527.527,0,0,0,.665.066l1.683-1.122a6.743,6.743,0,0,0,1.277.531l.4,2.016A.527.527,0,0,0,7.945,18h2.109a.527.527,0,0,0,.517-.424l.4-2.016a6.743,6.743,0,0,0,1.277-.531l1.683,1.122a.527.527,0,0,0,.665-.066l1.491-1.491a.527.527,0,0,0,.066-.665l-1.122-1.682a6.833,6.833,0,0,0,.531-1.278l2.016-.4A.527.527,0,0,0,18,10.055V7.945A.527.527,0,0,0,17.576,7.428ZM9,13.746A4.746,4.746,0,1,1,13.746,9,4.751,4.751,0,0,1,9,13.746Zm0,0",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemFill);
export default __webpack_public_path__ + "static/media/systemFill.3e98136dbeae7ac24869f821a91f9ae2.svg";
export { ForwardRef as ReactComponent };